import { createReducer, on } from '@ngrx/store';
import { AuthContext, AuthContextState } from '../interfaces/auth-context.interface';
import { CRUDMessages, MetaState } from '../interfaces/meta-state.interface';
import { AuthContextActionTypes, AuthContextActions, setCurrentAuthContextSpace, setCurrentAuthContextTenant } from './auth-context.actions';

export const initialAuthContextState: AuthContextState = {
  spaces: {},
  tenants: {},
  currentSpace: null,
  currentTenant: null,
  user: null,
  uri: null,
  ...(<MetaState<AuthContext, CRUDMessages>>{})
};

const reducer = createReducer<AuthContextState>(
  initialAuthContextState,
  on(AuthContextActions.getAuthContext, (state): AuthContextState => {
    console.debug('Action dispatched: ', AuthContextActions.getAuthContext.type);
    return {
      ...state,
      isLoading: true,
      result: {
        ...state.result,
        loaded: null
      }
    };
  }),
  on(AuthContextActions.setAuthContextSuccess, (state, { authContext }): AuthContextState => {
    console.debug('Action dispatched: ', AuthContextActions.setAuthContextSuccess.type);
    return {
      ...state,
      ...authContext,
      isLoading: false,
      result: {
        ...state.result,
        loaded: {
          message: 'loaded',
          data: authContext
        }
      }
    };
  }),
  on(AuthContextActions.setAuthContextError, (state, { error }): AuthContextState => {
    console.debug('Action dispatched: ', AuthContextActions.setAuthContextError.type);
    return {
      ...state,
      isLoading: false,
      result: {
        ...state.result,
        loaded: {
          message: 'loadError',
          error
        }
      }
    };
  }),
  on(AuthContextActions.login, (state): AuthContextState => {
    console.debug('Action dispatched: ', AuthContextActions.login.type);
    return {
      ...state,
      isLoading: true,
      result: {
        ...state.result,
        loaded: null
      }
    };
  }),
  on(AuthContextActions.loginSuccess, (state): AuthContextState => {
    console.debug('Action dispatched: ', AuthContextActions.loginSuccess.type);
    return {
      ...state,
      isLoading: false,
      result: {
        ...state.result,
        loaded: {
          message: 'loggedIn'
        }
      }
    };
  }),
  on(AuthContextActions.loginError, (state, { error }): AuthContextState => {
    console.debug('Action dispatched: ', AuthContextActions.loginError.type);
    return {
      ...state,
      isLoading: false,
      result: {
        ...state.result,
        loaded: {
          message: 'logInError',
          error: error
        }
      }
    };
  }),
  on(AuthContextActions.reset, (state): AuthContextState => {
    console.debug('Action dispatched: ', AuthContextActions.reset.type);
    return {
      ...state,
      ...initialAuthContextState
    };
  }),
  on(AuthContextActions.setUser, (state, { user }): AuthContextState => {
    console.debug('Action dispatched: ', AuthContextActions.reset.type);
    return {
      ...state,
      user
    };
  }),
  on(AuthContextActions.onDeleteSpaceSuccess, (state, { spaceUri }): AuthContextState => {
    console.debug('Action dispatched: ', AuthContextActions.reset.type);
    const spaces = { ...state.spaces };
    delete spaces[spaceUri]
    return {
      ...state,
      spaces: spaces
    };
  }),
  on(setCurrentAuthContextSpace, (state, { spaceUri }): AuthContextState => {
    console.debug('Action dispatched: ', setCurrentAuthContextSpace.type);
    return {
      ...state,
      currentSpace: state.spaces[spaceUri]
    };
  }),
  on(setCurrentAuthContextTenant, (state, { tenantUri }): AuthContextState => {
    console.debug('Action dispatched: ', setCurrentAuthContextTenant.type);
    return {
      ...state,
      currentTenant: state.tenants[tenantUri]
    };
  })
);

export const AuthContextReducer = (state = initialAuthContextState, actions: AuthContextActionTypes): AuthContextState => {
  return reducer(state, actions);
};
